import { validRegions } from "../../config/constants";
export const validateRegionValue = (region : string) => {
    return validRegions.includes(region);
};